import { isEmpty } from "./common-util";

/** Allowed format for user-typed email (local ASCII subset + domain + TLD). */
export const USER_INPUT_EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/;

export const isValidKtxAccountNumber = (accountNumber) => /^\d{6}[A-Za-z]$/.test(accountNumber);

export const validateErrorPartialForm = (form, fields = []) => {
  fields = fields.map((field) => (typeof field === "string" ? field : field.join(".")));
  return (
    form
      .getFieldsError()
      .filter(({ name }) => !fields.length || fields.includes(name.join(".")))
      .filter(({ errors }) => errors.length).length > 0
  );
};

export const formValueChangeGenerator = (isDataRemove) => {
  return (field, changes, onWrite, onRemove) => {
    if (field in changes) {
      const date = changes[field];
      if (isDataRemove(date)) onRemove?.(date);
      else onWrite(date);
    }
  };
};

export const onFormValueChange = formValueChangeGenerator(isEmpty);

export function validateNoEmailAndInValidSymbol(intl) {
  return (_, value) => {
    if (value && /\S+@\S+\.\S+/.test(value)) {
      return Promise.reject(new Error(intl.formatMessage({ id: "global.address.mailling-address.validate.no-email" })));
    }
    // \u0E00-\u0E7F : all Thai characters, including vowels and tonal marks
    if (value && /[^\u0E00-\u0E7Fa-zA-Z\d\s.,/\\\-()&'‘]+/.test(value)) {
      return Promise.reject(
        new Error(intl.formatMessage({ id: "global.address.mailling-address.validate.allow-symbol" }))
      );
    }
    return Promise.resolve();
  };
}
